module.exports = __webpack_public_path__ + "static/media/bg-lisbon.b4c4dbd2.jpeg";